import { create } from "zustand";
import { TBooking } from "~/types/booking";
import { TInventory } from "~/types/inventory";
import { TServiceTicket } from "~/types";
// Enhanced store with invoice configuration support

export enum BookingTab {
  OVERVIEW = "overview",
  SERVICES = "services",
  INVENTORY = "inventory",
  DOCUMENTS = "documents",
  TASKS = "tasks",
  NOTES = "notes",
  COMMUNICATION = "communication",
  BILLING = "billing",
}

type State = {
  booking?: TBooking;
  activeTab: BookingTab;
  selectedInventory?: TInventory;
  invoiceConfig?: InvoiceConfig;
  showServiceForm: boolean;
  showEstimateForm: boolean;
  showInventoryModal: boolean;
  showExpoModal: boolean;
  isAddingNewService: boolean;
  editingEstimateService?: TServiceTicket | null;
  tutorialMode: boolean;
};

type Actions = {
  setActiveTab: (tab: BookingTab) => void;
  setBooking: (booking: TBooking) => void;
  setSelectedInventory: (inventory?: TInventory) => void;
  setInvoiceConfig: (config: InvoiceConfig) => void;
  clearInvoiceConfig: () => void;
  setShowServiceForm: (show: boolean) => void;
  setShowEstimateForm: (show: boolean) => void;
  setShowInventoryModal: (show: boolean) => void;
  setShowExpoModal: (show: boolean) => void;
  setIsAddingNewService: (isAdding: boolean) => void;
  setEditingEstimateService: (service: TServiceTicket | null) => void;
  toggleTutorialMode: () => void;
};

const initialState: State = {
  activeTab: BookingTab.OVERVIEW,
  showServiceForm: false,
  showEstimateForm: false,
  showInventoryModal: false,
  showExpoModal: false,
  isAddingNewService: false,
  editingEstimateService: null,
  tutorialMode: false,
};

export const useDetailBookingStore = create<State & Actions>()((set) => ({
  ...initialState,
  setActiveTab: (tab) => set(() => ({ activeTab: tab })),
  setBooking: (booking) => set(() => ({ booking })),
  setSelectedInventory: (selectedInventory) => set(() => ({ selectedInventory })),
  setInvoiceConfig: (invoiceConfig) => set(() => ({ invoiceConfig })),
  clearInvoiceConfig: () => set(() => ({ invoiceConfig: undefined })),
  setShowServiceForm: (showServiceForm) => set(() => ({ showServiceForm })),
  setShowEstimateForm: (showEstimateForm) => set(() => ({ showEstimateForm })),
  setShowInventoryModal: (showInventoryModal) => set(() => ({ showInventoryModal })),
  setShowExpoModal: (showExpoModal) => set(() => ({ showExpoModal })),
  setIsAddingNewService: (isAddingNewService) => set(() => ({ isAddingNewService })),
  setEditingEstimateService: (editingEstimateService) => set(() => ({ editingEstimateService })),
  toggleTutorialMode: () => set((state) => ({ tutorialMode: !state.tutorialMode })),
}));
